class CartProgress {
  static async checkCartProgress() {
    const cart = await AjaxCart.getCart();
    if (!cart || !Array.isArray(cart.items)) return;
    if (!mov?.free_gift_product?.variantId) return;

    let freeGiftGoalReached = false;
    let giftExistInCart = false;
    let hasThreeMonthProduct = false;
    let hasSixMonthProduct = false;
    const currentGiftId = String(mov.free_gift_product.variantId);

    const THREE_MONTH_MIN_DAYS = 90;
    const SIX_MONTH_MIN_DAYS = 180;
    const MONTH_IN_DAYS_FALLBACK = 30;
    const ELIGIBLE_KEYWORDS = [
      'quarter',
      'quartal',
      'quarterly',
      'vierteljähr',
      'halbjahr',
      'half-year',
      'half year',
      'semiann',
      'trimestr',
      'semestr',
    ];

    const parseIntervalDays = (text) => {
      if (!text) return null;
      const lower = text.toString().toLowerCase();

      if (ELIGIBLE_KEYWORDS.some((keyword) => lower.includes(keyword))) {
        if (lower.includes('halb') || lower.includes('semestr')) {
          return SIX_MONTH_MIN_DAYS;
        }
        return THREE_MONTH_MIN_DAYS;
      }

      const dayMatch = lower.match(/(\d+)\s*(tage|day|days|d[ií]as?)/);
      if (dayMatch) {
        return parseInt(dayMatch[1], 10);
      }

      const monthMatch = lower.match(/(\d+)\s*(monat|monate|monats|month|months|meses|mes)/);
      if (monthMatch) {
        const months = parseInt(monthMatch[1], 10);
        if (!Number.isNaN(months)) {
          return months * MONTH_IN_DAYS_FALLBACK;
        }
      }

      const numberMatch = lower.match(/\b(90|180)\b/);
      if (numberMatch) {
        return parseInt(numberMatch[1], 10);
      }

      return null;
    };

    const isEligibleSellingPlan = (sellingPlan) => {
      if (!sellingPlan) return false;

      const candidateTexts = [];
      if (sellingPlan.name) candidateTexts.push(sellingPlan.name);

      if (Array.isArray(sellingPlan.options_with_values)) {
        sellingPlan.options_with_values.forEach((option) => {
          if (option?.name) candidateTexts.push(option.name);
          if (option?.value) candidateTexts.push(option.value);
          if (Array.isArray(option?.values)) {
            option.values.forEach((value) => candidateTexts.push(value));
          }
        });
      }

      for (const text of candidateTexts) {
        const intervalDays = parseIntervalDays(text);
        if (intervalDays === null) continue;
        if (intervalDays >= SIX_MONTH_MIN_DAYS) hasSixMonthProduct = true;
        if (intervalDays >= THREE_MONTH_MIN_DAYS) hasThreeMonthProduct = true;
      }
    };

    for (const item of cart.items) {
      const sellingPlan = item?.selling_plan_allocation?.selling_plan;
      if (sellingPlan) isEligibleSellingPlan(sellingPlan);
    }

    if (hasThreeMonthProduct || hasSixMonthProduct) {
      freeGiftGoalReached = true;
    }

    let keys = [];
    const staleGiftKeys = [];
    for (const item of cart.items) {
      const isMovProperty = item.properties && (item.properties._isMov === true || item.properties._isMov === 'true');
      if (!isMovProperty) continue;

      const isCurrentGift = String(item.variant_id) === currentGiftId;

      if (isCurrentGift) {
        giftExistInCart = true;
        keys.push(item.key);
        if (item.quantity > 1) {
          await AjaxCart.changeCart(JSON.stringify({
            id: item.key,
            quantity: 1
          }), 'mov');
        }
      } else {
        staleGiftKeys.push(item.key);
      }
    }

    for (const key of staleGiftKeys) {
      await AjaxCart.changeCart(JSON.stringify({
        id: key,
        quantity: 0
      }), 'mov');
    }

    const movProductId = String(mov.free_gift_product.productId || '');
    const welcomeKitHasMovGift = cart.items.some((item) => {
      const props = item.properties || {};
      const isMovLine = props._isMov === true || props._isMov === 'true';
      if (isMovLine) return false;
      if (String(item.variant_id) === currentGiftId) return true;
      return movProductId && String(item.product_id) === movProductId;
    });

    if (welcomeKitHasMovGift && keys.length) {
      for (const key of keys) {
        await AjaxCart.changeCart(JSON.stringify({
          id: key,
          quantity: 0
        }), 'mov');
      }
      keys = [];
      giftExistInCart = false;
    }

    const formBody = CartProgress.buildFormData(freeGiftGoalReached, keys, hasThreeMonthProduct, hasSixMonthProduct);
    const formsToAdd = welcomeKitHasMovGift
      ? formBody.filter((form) => String(form.id) !== currentGiftId)
      : formBody;

    if (freeGiftGoalReached) {
      if (welcomeKitHasMovGift) {
        for (const form of formsToAdd) {
          if (!form.id) continue;
          const alreadyInCart = cart.items.some((item) => String(item.variant_id) === String(form.id));
          if (!alreadyInCart) await AjaxCart.addToCart(JSON.stringify(form), 'mov');
        }
      } else if (!giftExistInCart) {
        for (const form of formBody) {
          if (!form.id) continue;
          await AjaxCart.addToCart(JSON.stringify(form), 'mov');
        }
      }
    } else if (giftExistInCart) {
      for (const form of formBody) {
        await AjaxCart.changeCart(JSON.stringify(form), 'mov');
      }
    }
  }

  static buildFormData(freeGiftGoalReached, keys, hasThreeMonthProduct, hasSixMonthProduct) {
    if (freeGiftGoalReached) {
      const itemsArray = [];

      if (hasThreeMonthProduct || hasSixMonthProduct) {
        itemsArray.push({
          'id': mov.free_gift_product.variantId,
          'quantity': 1,
          'properties': {
            '_isMov': true
          }
        });
      }

      if (hasSixMonthProduct && window.giftOption && mov.free_gift_product.variantId_2) {
        itemsArray.push({
          'id': mov.free_gift_product.variantId_2,
          'quantity': 1,
          'properties': {
            '_isMov': true
          }
        });
      }

      return itemsArray;
    }

    return keys.map((key) => ({
      'id': key,
      'quantity': 0
    }));
  }
}

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  if (event && event.source === 'mov') return;
  CartProgress.checkCartProgress();
});
